var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.11111V4C12 2.89543 12.8954 2 14 2H19.5C20.6046 2 21.5 2.89543 21.5 4V9.77778C21.5 10.8823 20.6046 11.7778 19.5 11.7778H11.0952H4.5C3.39543 11.7778 2.5 12.6732 2.5 13.7778V20C2.5 21.1046 3.39543 22 4.5 22H10C11.1046 22 12 21.1046 12 20V14.6667",
    stroke: "#3378F3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.662ee300089647ce534b215e7aec4813.svg";
export { ForwardRef as ReactComponent };